/**
 * Ant Design Theme Configuration
 * Generated from tokens.ts - DO NOT EDIT DIRECTLY
 *
 * To modify tokens, edit: client/src/design-system/tokens/tokens.ts
 * Then run: pnpm generate:tokens
 */

import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
    "cssVar": {
        "prefix": "ant"
    },
    "token": {
        "colorPrimary": "#b1359b",
        "colorPrimaryHover": "#c248a9",
        "colorPrimaryActive": "#a0238c",
        "colorLink": "#b1359b",
        "colorLinkHover": "#a0238c",
        "colorLinkActive": "#8a1d79",
        "colorText": "#111827",
        "colorTextSecondary": "#4b5563",
        "colorTextTertiary": "#6b7280",
        "colorTextQuaternary": "#d1d5db",
        "colorTextPlaceholder": "#6b7280",
        "colorPrimaryTextHover": "#6f155f",
        "colorTextDescription": "#9ca3af",
        "colorBgContainer": "#ffffff",
        "colorBgLayout": "#f9fafb",
        "colorBgElevated": "#ffffff",
        "colorBorder": "#d8dce2",
        "colorBorderSecondary": "#e5e7eb",
        "borderRadius": 6,
        "fontSize": 14,
        "fontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif"
    },
    "components": {
        "Button": {
            "controlHeightSM": 28
        },
        "Menu": {
            "itemHeight": 37,
            "itemPaddingInline": 10,
            "itemMarginInline": 10
        },
        "Card": {
            "headerHeightSM": 44
        }
    }
};

export default theme;
